module.exports = __webpack_public_path__ + "static/img/map.3425b845.jpg";